import classnames from 'classnames';
import esboard from 'images/scooter_esboard2.png';
import freego from 'images/scooter_freego2.png';
import unicool from 'images/scooter_unicool2.png';
import bolt from 'images/scooter_bolt.png';
import bchariot from 'images/scooter_bchariot.png';
import blueduck from 'images/scooter_blue_duck.png';
import styles from './ScooterPreview.module.scss';

export default function ScooterPreview({ model, inline }) {

  function getImage() {
    switch (model) {
      case 'esboard':
        return esboard;
      case 'freego':
        return freego;
      case 'unicool':
        return unicool;
      case 'bolt':
        return bolt;
      case 'bchariot':
        return bchariot;
      case 'okai':
      case 'x6':
        return blueduck;
      default:
        return blueduck;
    }
  }

  if (!model) {
    return null;
  }

  return (
    <div className={classnames(styles.container, {
      [styles.inline]: inline
    })}>
      <img className={styles.image} src={getImage()} alt="" />
    </div>
  )
}